module.exports = __webpack_public_path__ + "static/media/centerMatGrey95.767247e4.png";